import {AlertCircle, Ban, CheckCircle2, CircleHelp, Clock3, Inbox, LoaderCircle} from 'lucide-react'
import type {HistoryRecord, HistoryStatus} from '../../history/data/mockHistory'
import {getStatusStage, STATUS_COLUMNS, VALIDITY_LABELS, type StatusStage} from '../data/statusBoard'

export const STAGE_ICONS = {
  not_sent: Inbox, queued: Clock3, processing: LoaderCircle, sent: CheckCircle2,
  failed: AlertCircle, cancelled: Ban, unknown: CircleHelp,
}

export function statusColumn(stage: StatusStage) {
  return STATUS_COLUMNS.find((column) => column.id === stage)!
}

export function ValidityBadge({status}: {status: HistoryStatus}) {
  return <span className={`bs-validity bs-validity--${status}`}><span />{VALIDITY_LABELS[status]}</span>
}

export function StageBadge({record}: {record: HistoryRecord}) {
  const stage = getStatusStage(record)
  const column = statusColumn(stage)
  const Icon = STAGE_ICONS[stage]
  return <span className={`bs-stage bs-tone--${column.tone}`}><Icon size={13} aria-hidden='true' />{column.title}</span>
}

export function AuthorAvatar({name}: {name: string}) {
  const words = name.trim().split(/\s+/).filter(Boolean)
  const initials = words.length ? `${words[0][0]}${words.length > 1 ? words[words.length - 1][0] : ''}`.toUpperCase() : '?'
  return <span className='bs-avatar' aria-hidden='true'>{initials}</span>
}
